import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";

function Search() {
  const [recursos, setRecursos] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [learning, setLearning] = useState([]);
  const [contabilidad, setContabilidad] = useState([]);
  const [rrhh, setRRHH] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(null);
  const [searchText, setSearchText] = useState("");

  const user = useSelector((state) => state.auth.user);
  console.log(user);

  useEffect(() => {
    const fetchRecursos = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/recursos`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredRecursos = data.filter((recurso) => {
          if (!recurso.access || recurso.access.length === 0) {
            return true;
          } else {
            return recurso.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setRecursos(filteredRecursos);
      } catch (error) {
        console.log(error);
      }
    };

    fetchRecursos();
  }, [user.subarea]);

  useEffect(() => {
    const fetchProyectos = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/proyectos`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredProyectos = data.filter((proyecto) => {
          if (!proyecto.access || proyecto.access.length === 0) {
            return true;
          } else {
            return proyecto.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setProyectos(filteredProyectos);
      } catch (error) {
        console.log(error);
      }
    };

    fetchProyectos();
  }, [user.subarea]);

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/clientes`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredClientes = data.filter((cliente) => {
          if (!cliente.access || cliente.access.length === 0) {
            return true;
          } else {
            return cliente.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setClientes(filteredClientes);
      } catch (error) {
        console.log(error);
      }
    };

    fetchClientes();
  }, [user.subarea]);

  useEffect(() => {
    const fetchRRHH = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/rrhh`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredRRHH = data.filter((rrhh) => {
          if (!rrhh.access || rrhh.access.length === 0) {
            return true;
          } else {
            return rrhh.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setRRHH(filteredRRHH);
      } catch (error) {
        console.log(error);
      }
    };

    fetchRRHH();
  }, [user.subarea]);

  useEffect(() => {
    const fetchLearning = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/learning`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredLearning = data.filter((learning) => {
          if (!learning.access || learning.access.length === 0) {
            return true;
          } else {
            return learning.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setLearning(filteredLearning);
      } catch (error) {
        console.log(error);
      }
    };

    fetchLearning();
  }, [user.subarea]);

  useEffect(() => {
    const fetchContabilidad = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/contabilidad`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredContabilidad = data.filter((contabilidad) => {
          if (!contabilidad.access || contabilidad.access.length === 0) {
            return true;
          } else {
            return contabilidad.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setContabilidad(filteredContabilidad);
      } catch (error) {
        console.log(error);
      }
    };

    fetchContabilidad();
  }, [user.subarea]);

  const togglePopup = (rrhh) => {
    if (rrhh) {
      if (rrhh.popup) {
        setShowPopup(!showPopup);
        setPopupContent(rrhh);
      } else {
        window.open(rrhh.link, "_blank");
      }
    } else {
      setShowPopup(false);
      setPopupContent(null);
    }
  };

  const handleCopyToClipboard = (text, elemento) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    elemento.showCopiedAlert = true;
    setPopupContent({ ...popupContent });
    setTimeout(() => {
      elemento.showCopiedAlert = false;
      setPopupContent({ ...popupContent });
    }, 2000);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const allItems = [
    ...recursos,
    ...proyectos,
    ...clientes,
    ...rrhh,
    ...learning,
    ...contabilidad,
  ];

  const filteredItems = searchText
    ? allItems.filter(
        (item) =>
          item.name?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item.title?.toLowerCase()?.includes(searchText.toLowerCase())
      )
    : [];

  return (
    <div className="w-full flex flex-col">
      <h1 className="mx-auto text-3xl lg:text-4xl font-bold mt-4 mb-12">
        Buscar
      </h1>

      {/* Barra de búsqueda */}
      <input
        type="text"
        placeholder="Buscar por título..."
        value={searchText}
        onChange={handleSearchChange}
        className="px-4 py-2 mb-4 border border-gray-300 rounded-lg w-full"
      />

      <div className="flex flex-col max-w-7xl mx-auto md:grid md:grid-cols-3 lg:grid-cols-4 px-8">
        {/* Renderizar elementos filtrados */}
        {searchText !== "" &&
          (filteredItems.length > 0 ? (
            filteredItems.map((rrhh) => (
              <div key={rrhh.id} className="w-full mb-8 md:px-6">
                <button
                  className="flex flex-col bg-zinc-800 text-white shadow-md shadow-black rounded-3xl mx-auto cursor-pointer h-full"
                  onClick={() => togglePopup(rrhh)}
                >
                  <h2 className="text-center px-4 my-6 text-lg font-bold uppercase">
                    {rrhh.name} {rrhh.title}
                  </h2>
                  <div className="mx-auto h-48">
                    <div
                      className="rounded-[20%] overflow-hidden h-full w-full border-[1px] border-zinc-700"
                      style={{
                        width: "200px",
                        height: "200px",
                      }}
                    >
                      <div className="flex w-full h-full items-center justify-center">
                        <img src={rrhh.img} alt="" />
                      </div>
                    </div>
                  </div>
                  <p className="mx-auto text-center px-2 my-6 md:text-base flex items-center">
                    {rrhh.descripcion}
                  </p>
                </button>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">
              No se encontraron resultados.
            </p>
          ))}
      </div>

      {showPopup && popupContent && (
        <div className="fixed z-[1000] top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div
            className="bg-white p-4 rounded-lg"
            style={{ maxHeight: "85vh", overflowY: "auto" }}
          >
            <div className="text-black flex items-center p-2 rounded-t-lg w-full">
              <h3 className="mx-12 text-lg text-center font-semibold">
                {popupContent.name}
              </h3>
              <button
                className="absolute mr-0 flex font-extrabold p-2"
                onClick={() => togglePopup(null)}
              >
                X
              </button>
            </div>

            {popupContent.elemento.map((elemento) => (
              <div key={elemento.id}>
                <div className="bg-white text-black p-2">
                  {elemento.user && elemento.password && (
                    <div>
                      <h2 className="my-2">
                        Usuario:{" "}
                        <span
                          className="font-bold cursor-pointer"
                          onClick={() =>
                            handleCopyToClipboard(elemento.user, elemento)
                          }
                        >
                          {elemento.user}
                        </span>
                      </h2>
                      <h2 className="my-2">
                        Contraseña:{" "}
                        <span
                          className="font-bold cursor-pointer"
                          onClick={() =>
                            handleCopyToClipboard(elemento.password, elemento)
                          }
                        >
                          {elemento.password}
                        </span>
                      </h2>
                    </div>
                  )}
                  {elemento.showCopiedAlert && (
                    <div className="text-green-500 mt-2">
                      Copiado al portapapeles
                    </div>
                  )}
                </div>
                <a
                  className="w-auto flex justify-center items-center"
                  href={elemento.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={elemento.id}
                >
                  <button className="flex items-center justify-center mx-auto bg-[#ff6400] text-white px-4 py-2 rounded-xl mb-2">
                    <span>{elemento.title}</span>
                    <FaExternalLinkAlt className="ml-2" />
                  </button>
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Search;
